// Data that configures the Player Offensive Table
import { offensiveTeamTableRowItems } from '@/utils/dataTablesStructures/team';
import baseColumns from '@/data/team/baseColumns';

export default {
  columns: baseColumns,
  expandedRows: offensiveTeamTableRowItems.map(item => {
    if (!item.categoryIds) {
      return item.category;
    }
  }),
};
